import { render } from "./LoginProfile.vue?vue&type=template&id=3895781e"
import script from "./LoginProfile.vue?vue&type=script&lang=js"
export * from "./LoginProfile.vue?vue&type=script&lang=js"

import "./LoginProfile.vue?vue&type=style&index=0&id=3895781e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__